import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "n-tabs__list",
  ref: "scrollableEl"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1 1"} }, null, -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_tab_item = _resolveComponent("n-tab-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['n-tabs', { 'n-tabs_vertical': _ctx.isVertical, [_ctx.customClass]: _ctx.customClass }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['n-tabs__scroll-btn scroll-btn_left', { active: _ctx.scrollPosition > 5 && _ctx.showScrollArrows }])
    }, [
      _createVNode(_component_n_icon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleRewindScroll('left'))),
        name: "arrow-right"
      })
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (tab, index) => {
        return (_openBlock(), _createBlock(_component_n_tab_item, _mergeProps({
          key: tab.name
        }, tab, {
          size: _ctx.size,
          label: tab.label,
          tabIndex: _ctx.getTabIndex(index),
          active: _ctx.isActive(tab.name),
          direction: _ctx.direction,
          onTabSelect: ($event: any) => (_ctx.handleChange(tab.name)),
          onPrefixAction: ($event: any) => (_ctx.handlePrefixAction(tab.name)),
          onSuffixAction: ($event: any) => (_ctx.handleSuffixAction(tab.name))
        }), null, 16, ["size", "label", "tabIndex", "active", "direction", "onTabSelect", "onPrefixAction", "onSuffixAction"]))
      }), 128)),
      _hoisted_2,
      (_ctx.postfix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "postfix", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.postfix), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(['n-tabs__scroll-btn scroll-btn_right', { active: _ctx.scrollPosition < 95 && _ctx.showScrollArrows }])
    }, [
      _createVNode(_component_n_icon, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRewindScroll('right'))),
        name: "arrow-right"
      })
    ], 2)
  ], 2))
}